import objectAssign from 'object-assign';


export function article( state = { 
	post: {}, 
	comments: [],
	recommended: [],
	fetching: {
		article: false,
		comments: false,
		recommended: false
	}
}, action ) {

	switch( action.type ) {

		case 'REQUEST_ARTICLE':
			return Object.assign({}, state, {
				fetching: Object.assign({}, state.fetching, {article: true}),
			})

		case 'RECEIVE_ARTICLE':
			return Object.assign({}, state, {
				post: action.article,
				fetching: Object.assign({}, state.fetching, {article: false}),
			})

		case 'REMOVE_ARTICLE':
			return Object.assign({}, state, {
				post: {}
			})

		case 'RECEIVE_UPDATED_ARTICLE':
			return Object.assign({}, state, {
				post: action.article,
				fetching: Object.assign({}, state.fetching, {article: false}),
			})

		case 'REQUEST_COMMENTS':
			return Object.assign({}, state, {
				fetching: Object.assign({}, state.fetching, {comments: true}),
			})

		case 'RECEIVE_COMMENTS':
			return Object.assign({}, state, {
				comments: action.comments,
				fetching: Object.assign({}, state.fetching, {comments: false}),
			})

		case 'RECEIVE_NEW_COMMENT':
			return Object.assign({}, state, {
				comments: action.comments,
				fetching: Object.assign({}, state.fetching, {comments: false}),
			})

		case 'RECEIVE_UPDATED_COMMENT':

			var comments = state.comments;

			for (var a = 0; a <= comments.length - 1; a++) {

				if( comments[a].ID == action.comment.ID ) {
					comments[a].flares = action.comment.flares;
					comments[a].content = action.comment.content;
					break;
				}

				if( !comments[a].children ) continue;

				for (var s = 0; s <= comments[a].children.length - 1; s++) {
					if( comments[a].children[s].ID == action.comment.ID ) {
						comments[a].children[s].flares = action.comment.flares;
						comments[a].children[s].content = action.comment.content;
						break;
					}
				}

			}

			return Object.assign({}, state, {
				comments: comments,
				fetching: Object.assign({}, state.fetching, {comments: false}),
			})

		case 'REQUEST_RECOMMENDED_ARTICLES':
			return Object.assign({}, state, {
				recommended: [],
				fetching: Object.assign({}, state.fetching, {recommended: true}),
			})

		case 'RECEIVE_RECOMMENDED_ARTICLES':
			return Object.assign({}, state, {
				recommended: action.articles,
				fetching: Object.assign({}, state.fetching, {recommended: false}),
			})

		default:
			return state;

	}
	
}



// WEBPACK FOOTER //
// ./src/js/reducers/article.js